import type { ReactNode } from "react";

/** Solid accent text for PDF — print-safe replacement for .text-gradient */
export function PdfAccent({ children }: { children: ReactNode }) {
  return <span className="pdf-accent">{children}</span>;
}
